import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { CampaignService } from '../../services/campaign.service';
import { UntypedFormControl, Validators } from '@angular/forms';
import { filter, Subject, takeUntil } from 'rxjs';
import { selectCampaignSelected } from 'app/campaign/features/campaign.selectors';
import { select, Store } from '@ngrx/store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-campaign-cover-fee-settings',
  templateUrl: './campaign-cover-fee-settings.component.html',
  styleUrls: ['./campaign-cover-fee-settings.component.scss']
})
export class CampaignCoverFeeSettingsComponent implements OnInit, OnDestroy {

  @Input() formGroupCampaign: any = null;

  public campaign$ = this.store.pipe(
    select(selectCampaignSelected)
  );
  
  public takeUntilSubject: Subject<any> = new Subject();

  constructor(
    public campaignService: CampaignService,
    private store: Store
  ) { }

  ngOnInit(): void {
    const hideCoverFee = this.formGroupCampaign.get('hideCoverFee');

    this.campaignService.configGroup(this.formGroupCampaign, this.formGroupCampaign, {
      name: 'hideCoverFee',
      value: true
    }, [
      { name: 'coverFeeDefaultOff', defaultValue: false, validators: [], options: { disabled: true } },
      { name: 'donorFeeTextCheck', defaultValue: false, validators: [], options: { disabled: true } }
    ], this.takeUntilSubject);

    this.campaignService.configGroup(this.formGroupCampaign, this.formGroupCampaign, 'donorFeeTextCheck', [
      { name: 'coverFeeText', defaultValue: "", validators: [Validators.required] },
    ], this.takeUntilSubject);

    this.campaign$.pipe(
      filter(campaign => campaign !== null),
      takeUntil(this.takeUntilSubject)
    ).subscribe(() => {
      if(hideCoverFee.value) {
        const coverFeeDefaultOff = this.formGroupCampaign.get('coverFeeDefaultOff') as UntypedFormControl;
        coverFeeDefaultOff.disable();
  
        const donorFeeTextCheck = this.formGroupCampaign.get('donorFeeTextCheck') as UntypedFormControl;
        donorFeeTextCheck.disable();
      }
    });
  }

  ngOnDestroy(): void {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }

}
